/* @flow */

export const NUMBER_OF_STEPS = 4;

export const STEP_COMPANY = 'company';
export const STEP_FEATURES = 'features';
export const STEP_TEAM = 'team';
export const STEP_CRM_EXPERIENCE = 'crm-experience';
export const STEP_COMPLETE = 'complete';

// This is the source of truth for the order of the steps in the gathering process.
export const STEPS_PATHNAMES = [
    STEP_COMPANY,
    STEP_FEATURES,
    STEP_TEAM,
    STEP_CRM_EXPERIENCE,
    STEP_COMPLETE,
];

export const ANIMATION_SRC = {
    GET_TO_KNOW: '/include/rive/trial-gathering/get-to-know.riv',
    WHAT_BRINGS_YOU: '/include/rive/trial-gathering/what-brings-you.riv',
    TEAM_SIZE: '/include/rive/trial-gathering/team-size.riv',
    WHERE_IS_YOUR_DATA: '/include/rive/trial-gathering/where-is-your-data.riv',
};

export const PROVISIONED_MESSAGE = 'Instance provisioned';

export const DUMMY_PILLS = [
    "You're building your business",
    "You're growing your team",
    "You're scaling your business",
    "You're optimizing your workflow",
    "You're improving your sales process",
];

export const REASON_OPTIONS = [
    {value: 'track-contacts', title: 'Track contacts', pillText: 'You want to track contacts'},
    {
        value: 'automate-leads-with-a-sales-pipeline',
        title: 'Automate leads with a sales pipeline',
        pillText: 'You want to automate your sales pipeline',
    },
    {
        value: 'collect-from-website',
        title: 'Collect leads from my website',
        pillText: 'You want to collect leads from your website',
    },
    {
        value: 'teams-activity',
        title: "Report on my team's activity",
        pillText: 'You want to report on team activity',
    },
    {
        value: 'launch-email-campaigns',
        title: 'Launch email campaigns',
        pillText: 'You want to launch email campaigns',
    },
    {
        value: 'sms-outreach',
        title: 'Use SMS for outreach',
        pillText: 'You want to use SMS for outreach',
    },
    {
        value: 'log-calls',
        title: 'Automatically log and summarize calls',
        pillText: 'You want to log and summarize calls',
    },
    {
        value: 'measure-lead-sources',
        title: 'Measure lead sources',
        pillText: 'You want to measure lead sources',
    },
];

export const TEAM_SIZE_OPTIONS = [
    {
        value: 'no',
        title: 'Just me',
        pillText: "You're flying solo",
    },
    {
        value: 'two',
        title: '2-3 people',
        pillText: 'You are a team of 2-3 people',
    },
    {
        value: 'small',
        title: '4-10 people',
        pillText: 'You are a team of 4-10 people',
    },
    {
        value: 'large',
        title: '11-20 people',
        pillText: 'You are a team of 11-20 people',
    },
    {
        value: 'xl',
        title: '21-50 people',
        pillText: 'You are a team of 21-50 people',
    },
    {
        value: '2xl',
        title: '50-100 people',
        pillText: 'You are a team of 50-100 people',
    },
    {
        value: '3xl',
        title: '100+ people',
        pillText: 'You are a team of 100+ people',
    },
];

export const DATA_SOURCE_OPTIONS = [
    {value: 'spreadsheets', title: 'Spreadsheets', pillText: 'Your data is in spreadsheets'},
    {value: 'email-inboxes', title: 'Email inboxes', pillText: 'Your data is in email inboxes'},
    {value: 'other-crm', title: 'Another CRM or system', pillText: 'Your data is in another CRM'},
    {
        value: 'new',
        title: 'Our business is just getting started',
        pillText: 'Your business is just getting started',
    },
];
